import * as TypeGraphQL from "type-graphql";
export var ActionStatus;
(function (ActionStatus) {
    ActionStatus["STAGED"] = "STAGED";
    ActionStatus["PENDING"] = "PENDING";
    ActionStatus["EXECUTED"] = "EXECUTED";
    ActionStatus["COMPLETED"] = "COMPLETED";
    ActionStatus["CANCELED"] = "CANCELED";
})(ActionStatus || (ActionStatus = {}));
TypeGraphQL.registerEnumType(ActionStatus, {
    name: "ActionStatus",
    description: undefined,
});
//# sourceMappingURL=ActionStatus.js.map